'use client';

import { useEffect, useRef } from 'react';
import { playClick } from '@/utils/audio';

export const useCompassSound = (activeTick: number) => {
  const previousTick = useRef(activeTick);

  useEffect(() => {
    if (previousTick.current === activeTick) return;
    previousTick.current = activeTick;
    playClick();
  }, [activeTick]);
};
